import React from 'react'
import { ProductBaseOnCategory } from '../../../types/product';
import { updatePackageTHeadData } from '../../../data/admin-data';
import Loading from '../../ui/Loading';
import ErrorMessage from '../../ui/ErrorMessage';
import { ProductPackage } from '../../../types/package';

interface UpdatePackageItemAvailableTBodyProps {
    isLoading: boolean;
    isError: boolean;
    isEmpty: boolean;
    errorMessage: string;
    data: ProductBaseOnCategory[]
    currentPackage: ProductPackage[]
    handleAddProductToPackage: (value: ProductBaseOnCategory) => void;
}

export default function UpdatePackageItemAvailableTBody({ handleAddProductToPackage, currentPackage, isLoading, isError, isEmpty, errorMessage, data }: UpdatePackageItemAvailableTBodyProps) {
    return (
        <tbody className='w-full'>
            {isLoading ? (
                <tr>
                    <td colSpan={updatePackageTHeadData.length}  className='h-auto text-center'> 
                        <div className="flex space-x-1 justify-center items-center w-full h-full">
                            <Loading message="Loading product..." />
                        </div>
                    </td>
                </tr>
            ) : isError ? (
                <tr>
                    <td colSpan={updatePackageTHeadData.length}  className="py-8">
                        <div className="flex items-center justify-center w-full text-xs">
                            <ErrorMessage message={errorMessage} textStyle={``}/>
                        </div>
                    </td>
                </tr>
            ) : isEmpty ? (
                <tr>
                    <td colSpan={updatePackageTHeadData.length}  className="py-8">
                        <div className="flex items-center justify-center w-full text-xs">
                            <p className='text-gray-500 text-xs'>No result found.</p>
                        </div>
                    </td>
                </tr>
            ) : (
                data.map((product, index) => {
                    const isInPackage = currentPackage?.some((item) => item.productId === product.productID && item.productSize === product.sizeInfo.size);
                    const addons = product.addons ?? [];
                    const category = (product?.categoryInfo.categoryName === "null" || product?.categoryInfo.categoryName === null) ? "" : product?.categoryInfo.categoryName ?? ""
                    return (
                        <tr 
                            key={product.productID} 
                            className={`hover:bg-gray-100 text-xs cursor-pointer ${index % 2 === 0 ? "bg-white" : "bg-gray-100"}`}
                        >
                            <th className="capitalize px-2.5 py-1.5 text-left border border-gray-200">
                                <div className="truncate font-normal">
                                    {product.productName} 
                                </div>
                            </th>
                            <th className="capitalize px-2.5 py-1.5 text-left border border-gray-200">
                                <div className="truncate font-normal">
                                    {product?.typeInfo.typeName ?? ''}
                                </div>
                            </th>
                            <th className="capitalize px-2.5 py-1.5 text-left border border-gray-200">
                                <div className="truncate font-normal">
                                    {category}
                                </div>
                            </th>
                            <th className="capitalize px-2.5 py-1.5 text-left border border-gray-200">
                                <div className="truncate font-normal">
                                    {product?.sizeInfo.size ?? ''}
                                </div>
                            </th>
                            <th className="capitalize px-2.5 py-1.5 text-left border border-gray-200">
                                <div className="truncate font-normal">
                                    {product.price}
                                </div>
                            </th>
                            <th className="capitalize px-2.5 py-1.5 text-left border border-gray-200">
                                <div className="col-span-2 mt-1 flex flex-col text-[11px] text-gray-600">
                                    {addons.map((add) => (
                                        <div key={add.addonID}>{add.addonName}</div>
                                    ))}
                                </div>
                            </th>
                            <th className="capitalize px-2.5 py-1.5 text-left border border-gray-200">
                                <input
                                    type="checkbox"
                                    checked={isInPackage}
                                    onChange={() => {
                                        handleAddProductToPackage(product)
                                    }}
                                    className="cursor-pointer accent-cbColor"
                                />
                            </th>
                        </tr>
                    )
                })
            )}
        </tbody>
    )
}
